import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import SortBy from "types/practices/SortBy";

export interface Filters {
  search_term: string | undefined;
  status: string | undefined;
}

export interface Sorting {
  sort_by: SortBy | undefined;
}

export type InitialState = {
  filtering: Filters;
  sorting: Sorting;
};

const initialState: InitialState = {
  filtering: {
    search_term: undefined,
    status: undefined,
  },
  sorting: {
    sort_by: undefined,
  },
};

export const practiceManagementFilters = createSlice({
  name: "practiceManagementFilters",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<Filters>>) => {
      state.filtering.search_term = action.payload?.search_term;
      state.filtering.status = action?.payload.status;
    },

    setSorting: (state, action: PayloadAction<Partial<Sorting>>) => {
      state.sorting.sort_by = action.payload.sort_by;
    },

    clearFilters: (state) => {
      state = {
        filtering: {
          search_term: undefined,
          status: undefined,
        },
        sorting: {
          sort_by: undefined,
        },
      };
    },
  },
});

export const { setFilters, setSorting, clearFilters } =
  practiceManagementFilters.actions;

export default practiceManagementFilters.reducer;
